import { Link } from "react-router-dom";

import { useWsPath } from "../../workspaces";
import { useTokenwisePlan } from "../../services/stigg";

/* Trial/plan indicator for the app's dark maroon header (OPSS-55). Styled as a chip that
 * sits on the dark header (translucent white, matching the header's own controls) rather
 * than the light-surface design-system Badge. Trial-ended flips to a filled white "upgrade"
 * chip (like the Add Agent button) to draw the eye. Renders nothing for paid/premium
 * customers and when Stigg is not configured. */
export function TrialStatusBadge() {
  const ws = useWsPath();
  const { isLoading, hasSubscription, isEntitled, isTrial, trialDaysLeft } =
    useTokenwisePlan();

  // No indicator unless the customer is actually on Tokenwise (has a subscription).
  // Avoids nagging AI21 employees (pro via a company plan / the backend bypass) and any
  // user for whom the stigg-enabled flag hasn't provisioned a Tokenwise trial.
  if (isLoading || !hasSubscription) return null;

  const billingPath = ws("/settings/billing");
  const base =
    "inline-flex h-7 shrink-0 items-center rounded-full px-3 text-[12px] font-medium no-underline transition-colors";

  if (isTrial) {
    const label =
      trialDaysLeft !== undefined
        ? `Free trial · ${trialDaysLeft} days left`
        : "Free trial";
    return (
      <Link
        to={billingPath}
        aria-label="View plan and billing"
        className={`${base} bg-white/10 text-white hover:bg-white/[0.16]`}
      >
        {label}
      </Link>
    );
  }

  if (!isEntitled) {
    return (
      <Link
        to={billingPath}
        aria-label="Upgrade Tokenwise"
        className={`${base} bg-white font-semibold text-[#280611] hover:bg-white/90`}
      >
        Trial ended · Upgrade
      </Link>
    );
  }

  return null;
}
